export default {
  setOfferStatusesList (state, payload) {
    state.offerStatusesList = payload
  }
}
